import { connect, Dispatch } from 'react-redux';
import { Action, load } from 'redux/modules/shopify';

import AccessoriesPageStatelessWrapper, { DispatchProps } from 'components/pages/accessories/AccessoriesPage';

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        loadData: () => dispatch<any>(load())
    };
};

export default connect(null, mapDispatchToProps)(AccessoriesPageStatelessWrapper);



// WEBPACK FOOTER //
// ./src/containers/pages/accessories/AccessoriesPage.tsx